import { RandomLocationsApi } from "@anyways-open/random-locations-sdk";
import { EditApi } from "./EditApi";
import { IdentityApi } from "@anyways-open/identity-api-client";
import { ProjectApi } from "./projects/ProjectApi";
import { PublishApi } from "./publish/PublishApi";
import { TripsApi } from "@anyways-open/trips-api-client";
import { DemandModelApi } from "./demand-model/DemandModelApi";
/**
 * A collection of all APIs used.
 */
export class Api {
    constructor(accessTokenProvider, settings) {
        this.accessTokenProvider = accessTokenProvider;
        this.edit = new EditApi(settings.editApi);
        this.projects = new ProjectApi({
            url: settings.projectsApi
        });
        this.publish = new PublishApi({
            url: settings.publishApi,
            tilesUrl: settings.publishApiTiles
        });
        this.randomLocations = new RandomLocationsApi(settings.randomLocationsApi);
        this.trips = new TripsApi({
            url: settings.tripsApi
        });
        this.identity = new IdentityApi(settings.identityApi);
        this.demandModel = new DemandModelApi(settings.demandModelApi);
    }
    /**
     * Gets an access token.
     * @returns The access token.
     */
    async getAccessToken() {
        return await this.accessTokenProvider.getAccessToken();
    }
}
